import React, { Fragment } from 'react';
import { resolve } from 'library/helpers/path-resolver';
import PropTypes from 'prop-types';
import withConfig from 'util/hoc/with-config';
import PairinCurriculum from 'apps/personal/modules/curriculum/pairin';
import TiCurriculum from 'apps/personal/modules/curriculum/ti';
import PreviewCourses from 'apps/personal/modules/curriculum/preview';

const EXCLUDED_TYPES = [
  'Manager',
  'Teacher'
];

class Curriculum extends React.PureComponent {
  static propTypes = {
    nodes: PropTypes.arrayOf(PropTypes.shape({
      ti_sublicense_id: PropTypes.string
    })),
    configuration: PropTypes.object.isRequired
  }

  filterExcludedUserTypes = (n) => (
    n.user_types.filter(t => EXCLUDED_TYPES.includes(t)).length === 0
  )

  render() {
    const {
      nodes,
      configuration,
      ...props
    } = this.props;

    if (resolve(configuration, 'apps/personal/configuration/has_ti', false)) {
      return (
        <Fragment>
          {
            nodes.filter(this.filterExcludedUserTypes).filter(n=>n.ti_sublicense_id).map((n)=>(
              <TiCurriculum key={n.id} audience={resolve(configuration, 'apps/personal/configuration/ti_highschool', false)?'high school':'adult'} node={n} {...props} />
            ))
          }
          {resolve(configuration, 'apps/personal/configuration/preview_curriculum', false)
            ?
            <PreviewCourses
              preview_courses={resolve(configuration, 'apps/personal/configuration/preview_courses', {})}
              audience={resolve(configuration, 'apps/personal/configuration/ti_highschool', false)?'high school':'adult'}
            />
            : null
          }
        </Fragment>
      );
    }

    return (
      <Fragment>
        <PairinCurriculum {...props} />
        {resolve(configuration, 'apps/personal/configuration/preview_curriculum', false)
          ?
          <PreviewCourses
            preview_courses={resolve(configuration, 'apps/personal/configuration/preview_courses', {})}
            audience={resolve(configuration, 'apps/personal/configuration/ti_highschool', false)?'high school':'adult'}
          />
          : null
        }
      </Fragment>
    );
  }
}

export default withConfig(Curriculum);
